import script from "./SignatureMakercartSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureMakercartSection.vue?vue&type=script&setup=true&lang=js"

import "./SignatureMakercartSection.vue?vue&type=style&index=0&id=3a16435c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a16435c"]])

export default __exports__